<template>
  <div class="newsletter__text" v-if="!isFormSend && !formSendError">
    <p class="text--bold text--no-margin-bottom">{{ t('newsletter.copy') }}</p>
  </div>
  <div class="newsletter__form" v-if="!isFormSend && !formSendError">
    <form class="form form--initialized" @submit.prevent="handleSubmit">
      <div class="form__body">
        <div class="form__control" role="group">
          <div class="form__control-content form__control-content--gap--16">
            <div class="form__row form__row--gap-lg">
              <div class="row">
                <InputField :label="t('newsletter.name.label')"
                            id="newsletter-name"
                            v-model="formData.name"
                            @validation-change="handleNameValidation"
                            :force-validation="forceValidationOnSubmit"
                            :rules="nameRules"
                            :inverted="true"
                            :placeholder="t('newsletter.name.placeholder')"
                            autocomplete="name" />
              </div>
              <div class="row">
                <InputField :label="t('newsletter.email.label')"
                            id="newsletter-email"
                            v-model="formData.email"
                            type="email"
                            :inverted="true"
                            @validation-change="handleEmailValidation"
                            :force-validation="forceValidationOnSubmit"
                            :rules="emailRules"
                            :placeholder="t('newsletter.email.placeholder')"
                            autocomplete="email" />
              </div>
            </div>
            <div class="form__row">
              <div class="row row--mt-base">
                <Checkbox :label="`${t('newsletter.privacy.labelPreLink')} <a class='link link--negative' href='${countryLanguagePath}${t('newsletter.privacy.link')}' target='_blank'>${t('newsletter.privacy.labelLink')}</a> ${t('newsletter.privacy.labelPostLink')}`"
                          id="newsletter-privacy"
                          :rules="privacyRules"
                          v-model="formData.privacy"
                          :formatLabelHtml="true"
                          :inverted="true"
                          @validation-change="handlePrivacyValidation"
                          :force-validation="forceValidationOnSubmit" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form__footer">
        <div class="form__row">
          <Submit :loading="isSubmitLoading"
                  :label="t('newsletter.submit.label')" />
        </div>
      </div>
    </form>
  </div>
  <div class="newsletter__msg-container" aria-live="polite" v-if="isFormSend && !formSendError">
    <span class="newsletter__thank-you-msg newsletter__thank-you-msg--bold">{{ t('newsletter.thanks.title') }}</span>
    <span class="newsletter__thank-you-msg">{{ t('newsletter.thanks.copy') }}</span>
  </div>
  <div class="newsletter__msg-container" aria-live="polite" v-if="!isFormSend && formSendError">
    <span class="newsletter__thank-you-msg newsletter__thank-you-msg--bold">{{ t('newsletter.error.title') }}</span>
    <span class="newsletter__thank-you-msg">{{ t('newsletter.error.copy') }}</span>
  </div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n';
import axios from 'axios';
import InputField from './components/fields/InputField.vue';
import Submit from './components/fields/Submit.vue';
import Checkbox from './components/fields/Checkbox.vue';
import {getCountryAndLanguagePathFromUrl} from '../../abstracts/utilities.js';
import {trackData} from './utilities.js';
const countryLanguagePath = window.location.origin + '/' + getCountryAndLanguagePathFromUrl();

const formData = reactive({
  name: '',
  email: '',
  privacy: false
})

const isValidName = ref(false);
const isValidEmail = ref(false);
const isValidPrivacy = ref(false);
const isFormSend = ref(false);
const formSendError = ref(false);
const isSubmitLoading = ref(false);

const forceValidationOnSubmit = ref(false);

const { t } = useI18n()
const nameRules = [
  (value) => value.length > 0 || t('newsletter.name.error.empty')
];

const emailRules = [
  (value) => value.length > 0 || t('newsletter.email.error.empty'),
  (value) => /.+@.+\..+/.test(value) || t('newsletter.email.error.email'),
];

const privacyRules = [
  (value) => value === true || t('newsletter.privacy.error'),
];

const handleNameValidation = (isValid) => {
  isValidName.value = isValid;
};

const handleEmailValidation = (isValid) => {
  isValidEmail.value = isValid;
};

const handlePrivacyValidation = (isValid) => {
  isValidPrivacy.value = isValid;
};

const isFormValid = computed(() => isValidName.value && isValidEmail.value && isValidPrivacy.value);

const handleSubmit = () => {
  forceValidationOnSubmit.value = true;
  isSubmitLoading.value = true;

  setTimeout(() => {
    if (isFormValid.value) {

      axios.post(window.location.origin + '/' + getCountryAndLanguagePathFromUrl() + '/send/newsletter/', formData).then(response => {
        console.info(response.status);

        isFormSend.value = true;
        formSendError.value = false;

        trackData({
          'event': 'generate_lead',
          'form_name': 'Newsletter'
        });
      }).catch(error => {
        console.warn(error.status);

        isFormSend.value = false;
        formSendError.value = true;
      });

    } else {
      isSubmitLoading.value = false;
    }
  }, 0);
};

</script>
